module.exports = __webpack_public_path__ + "static/media/parkingAvailable.52db6e4a.svg";